/**
 * Matches `theme/base.css`'s `.bar`/`.bar > i` geometry — a thin, fully
 * rounded track — since the palette's `primary`/`error`/`success` already
 * resolve to `--accent-solid`/`--danger-solid`/`--ok-solid` (see
 * `theme/palette.ts`), so the track/fill colours need no override of their
 * own to land close to the hand-rolled version.
 */
import type { Components, Theme } from '@mui/material/styles';

export const MuiLinearProgress: Components<Theme>['MuiLinearProgress'] = {
	styleOverrides: {
		root: {
			height: 6,
			borderRadius: 'var(--r-full)',
		},
		bar: {
			borderRadius: 'var(--r-full)',
			transition: 'transform 0.6s ease',
		},
	},
};
